export default "__VITE_ASSET__f41cdecb__"